import { FC, memo } from 'react';

import { SectionContainer } from '../SectionContainer/SectionContainer';
import { Grid, GridItem } from './SectionFields.styles';
import { FieldsSectionProps } from './SectionFields.types';

const SectionFields: FC<FieldsSectionProps> = (props) => {
    const { title, fieldsDefs, columnsCount = 3 } = props;

    const isEmptySection = fieldsDefs.every((field) => !field.value);

    if (isEmptySection) {
        return null;
    }

    return (
        <SectionContainer title={title}>
            <Grid columnsCount={columnsCount}>
                {fieldsDefs.map((field, index) => (
                    <GridItem key={index} {...field} columnsCount={columnsCount} hideIfEmpty />
                ))}
            </Grid>
        </SectionContainer>
    );
};

export default memo(SectionFields);
